import { render, staticRenderFns } from "./LandingPageEn.vue?vue&type=template&id=3f5157ea"
import script from "./LandingPageEn.vue?vue&type=script&lang=js"
export * from "./LandingPageEn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports